import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import successMessages from 'network/messages/successMessages'

export const getGamificationDataService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'gamification/get-data', data, {
    server: microServices.USER_URL
  })
}

